import React, { useContext } from 'react';
import myContext from '@/utils/createContext';
import GooglePayButton from '@google-pay/button-react';
import { getEnv } from '@/utils/index';
import { message, Spin } from 'antd';

function CashierGooglePayButton(props) {
  const ctx = useContext(myContext);
  const {
    googlePayConfigInfoBean,
    onReadyToPayGoogleChange,
    isButtonVisibleGP,
    transactionInfo: walletTransactionInfo,
    onCashierGooglePayLoadPaymentData,
  } = { ...ctx, ...props };

  const { allowedPaymentMethods, merchantInfo, countryCode } =
    googlePayConfigInfoBean || {};

  const { totalPrice, currencyCode } = walletTransactionInfo || {};

  // 配置或金额不完整时不渲染按钮，避免 SDK 因缺少必填字段报错
  const isConfigReady =
    !!merchantInfo &&
    !!allowedPaymentMethods &&
    !!totalPrice &&
    !!currencyCode;

  if (process.env.NODE_ENV !== 'production' && !isConfigReady) {
    const missing = { merchantInfo, allowedPaymentMethods, totalPrice, currencyCode };
    const missingKeys = Object.entries(missing)
      .filter(([, v]) => !v)
      .map(([k]) => k);
    console.warn('[CashierGooglePayButton] missing required fields:', missingKeys.join(', '));
  }

  const isEnvProduction = getEnv() === 'production';

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        background: '#fff',
        height: '70px',
      }}
    >
      {isConfigReady && (
        <GooglePayButton
          id="cashier_googlepay_button"
          environment={isEnvProduction ? 'PRODUCTION' : 'TEST'}
          buttonColor="default"
          buttonType="buy"
          paymentRequest={{
            apiVersion: 2,
            apiVersionMinor: 0,
            allowedPaymentMethods,
            merchantInfo,
            transactionInfo: {
              totalPrice,
              currencyCode,
              countryCode,
              totalPriceStatus: 'FINAL',
            },
          }}
          style={{
            display: isButtonVisibleGP === true ? 'inline-block' : 'none',
          }}
          onLoadPaymentData={onCashierGooglePayLoadPaymentData}
          onReadyToPayChange={onReadyToPayGoogleChange}
          onError={(error) => {
            const msg =
              error instanceof Error
                ? error.message
                : error?.statusMessage || 'Google Pay error';
            message.error(msg);
          }}
        />
      )}
      {isButtonVisibleGP === null && <Spin />}
    </div>
  );
}

export default CashierGooglePayButton;
